import { UserRoleEnum } from '../enums/userRoleEnum';

export class LoginResult {
    static readonly storage_key = 'UserInfo';
    token: string;
    userName: string;
    firstName: string;
    lastName: string;
    roleId: UserRoleEnum;
    expireDate: Date | number | string;
    visitorId: string; 
    msg: string; 
    flag: number;  
  }
